import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Carousel } from 'react-responsive-carousel';
import 'tachyons';

class Recommandations extends Component {
    render() {
        return (
            <div className="tc">
                              <h1 className="f1" style={{font:'Gerogia'}}>Page under construction</h1>

            </div>
        );
    }
}
 
export default Recommandations;



// WEBPACK FOOTER //
// ./src/components/Recommandations.js